<zip-co-header></zip-co-header>

<main class="error-unavailable">
  <div class="container">
    <div class="right">
      <img src="assets/satellite.svg" width="160" height="160" alt="Satellite" />
      <h1 class="error__heading">Gift cards are currently unavailable.</h1>
      <p class="error__copy">
        Shop everywhere online where Visa is accepted with Zip's single-use card feature on the Zip
        mobile app. Or shop anywhere instore you see Zip at checkout - we've partnered with 52,000+
        retail stores.
      </p>
      <a class="btn" href="/au/shop"> Continue shopping </a>
    </div>
  </div>
</main>

<app-footer></app-footer>
